import { Injectable }        from '@angular/core';
import { Store }             from '@ngrx/store';
import { clearViewDocument } from '../../state/app.actions';
import {
  selectViewDocumentType,
  selectViewDocumentUrl,
}                            from '../../state/app.selectors';

@Injectable({
  providedIn: 'root',
})
export class ViewDocumentService {
  viewDocumentType$ = this.store.select(selectViewDocumentType);
  viewDocumentUrl$ = this.store.select(selectViewDocumentUrl);

  constructor(private readonly store: Store) {
  }

  clearViewDocument() {
    this.store.dispatch(clearViewDocument());
  }
}
